import MuiTable from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Skeleton from '@mui/material/Skeleton';
import { styled } from '@mui/material/styles';
import { Typography } from '@components/Typography';
import { TABLE_BODY_CELL_HEIGHT, TABLE_BODY_CELL_PADDING } from '@components/Table/tableLayout';
import { useTranslation } from '@hooks';
import { InsightsCard } from './styles';

const HEADER_BG = 'var(--action-hover)';
const ROW_HOVER_BG = 'var(--action-highlight)';

const HeaderCell = styled(TableCell)({
    borderBottom: 'none',
    padding: '12px 16px',
    whiteSpace: 'nowrap',
    backgroundColor: HEADER_BG,
});

const BodyCell = styled(TableCell)({
    padding: TABLE_BODY_CELL_PADDING,
    height: TABLE_BODY_CELL_HEIGHT,
});

const StyledTableRow = styled(TableRow)({
    cursor: 'pointer',
    '&.MuiTableRow-hover:hover': {
        background: ROW_HOVER_BG,
    },
});

const TopCategoriesCard = ({ title, subtitle, data, loading, onRowClick }) => {
    const { t } = useTranslation();

    return (
        <InsightsCard>
            <div style={{ marginBottom: 16 }}>
                <Typography variant="title1" color="textPrimary" style={{ display: 'block' }}>
                    {title}
                </Typography>
                {subtitle && (
                    <Typography variant="caption" color="textSecondary" style={{ display: 'block', marginTop: 4 }}>
                        {subtitle}
                    </Typography>
                )}
            </div>
            {loading ? (
                <>
                    {[...Array(5)].map((_, i) => (
                        <Skeleton key={i} height={45} sx={{ mb: 0.5 }} />
                    ))}
                </>
            ) : data.length === 0 ? (
                <Typography
                    variant="body2"
                    color="textSecondary"
                    style={{ display: 'block', textAlign: 'center', padding: '24px 0' }}
                >
                    —
                </Typography>
            ) : (
                <TableContainer>
                    <MuiTable>
                        <TableHead>
                            <TableRow>
                                <HeaderCell>
                                    <Typography variant="subtitle2">{t('common.category', { count: 2 })}</Typography>
                                </HeaderCell>
                                <HeaderCell align="right">
                                    <Typography variant="subtitle2" align="right">
                                        {t('common.review', { count: 2 })}
                                    </Typography>
                                </HeaderCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map(item => (
                                <StyledTableRow key={item.category} hover onClick={() => onRowClick(item.category)}>
                                    <BodyCell>
                                        <Typography variant="body2">
                                            {t(`themes.${item.category}`, item.category)}
                                        </Typography>
                                    </BodyCell>
                                    <BodyCell align="right">
                                        <Typography variant="body2" align="right">
                                            {item.reviewCount}
                                        </Typography>
                                    </BodyCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </MuiTable>
                </TableContainer>
            )}
        </InsightsCard>
    );
};

export default TopCategoriesCard;
